<template lang="pug">
  DefaultLayout
    CommonSection(title="Контакты")
      template(#button)
        Btn(lg dark @click="$refs.list.add()")
          Icon(name="plus" pointer)
          | Добавить
      ContactList(ref="list")
</template>

<script>
import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';

import ContactList from '@/components/ContactList.vue';

export default {
  name: 'ContactsPage',
  components: {
    CommonSection,
    DefaultLayout,
    ContactList,
  },
};
</script>
